/*eslint-disable*/
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";

// components
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  InputLabel,
  TextField,
  CircularProgress,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import StatusBadge from "../statusBadge";

// hooks
import useSort from "../../../../hooks/useSort";
import { useTranslation } from "react-i18next";
// constants

import { selectBulkStatusesArray } from "../../../../store/selectors/uploadStatus";

//styles
import styles from "./bulkUsersUploadStatuses.module.scss";
import { fetchUser } from "../../../../services/user";

function BulkUsersUploadStatuses({ isFetching }) {
  const bulkUserUploadStatuses = useSelector(selectBulkStatusesArray);
  const { t } = useTranslation()

  const [email, setEmail] = useState('');
  // useEffect(()=>{
  //     const fetchUserEmail = async()=>{
  //       console.log(bulkUserUploadStatuses.jobOwner);
  //       const userData = await fetchUser(bulkUserUploadStatuses.jobOwner)
  //       setEmail(userData.userName)
  //     }
  //     fetchUserEmail()
  // },[bulkUserUploadStatuses?.jobOwner])


  
  useEffect(() => {
    if (bulkUserUploadStatuses.jobOwner) {
      const fetchEmail = async () => {
        try {
          const userData = await fetchUser(bulkUserUploadStatuses.jobOwner);
              setEmail(userData?.data?.userName); 
          } catch (error) {
              console.error(error);
           }
        };
    
       fetchEmail();
       }
     }, [bulkUserUploadStatuses.jobOwner]);
    


  const { sortBy, sortOrder, handleSort } = useSort({
    initialSortBy: "",
    initialSortOrder: "asc",
  });


  const renderTableHead = () => (
    <TableRow>
      <TableCell className={styles.tableHeader}>
        <TableSortLabel
          active={sortBy === "processedTimeStamp"}
          direction={sortOrder}
          onClick={() => handleSort("processedTimeStamp")}
        >
          {t('bulk-search-date')}
        </TableSortLabel>
      </TableCell>
      <TableCell className={styles.tableHeader}>
        <TableSortLabel
          active={sortBy === "email"}
          direction={sortOrder}
          onClick={() => handleSort("email")}
        >
          {t('bulk-search-file-owner')}
        </TableSortLabel>
      </TableCell>
      <TableCell className={styles.tableHeader}>
        <TableSortLabel
          active={sortBy === "fileName"}
          direction={sortOrder}
          onClick={() => handleSort("fileName")}
        >
          {t('bulk-search-job-id')}
        </TableSortLabel>
      </TableCell>
      <TableCell className={styles.tableHeader}>
        <TableSortLabel
          active={sortBy === "status"}
          direction={sortOrder}
          onClick={() => handleSort("status")}
        >
          {t('bulk-search-status')}
        </TableSortLabel>
      </TableCell>
    </TableRow>
  );

  const renderTableBody = () => {
    // return bulkUserUploadStatuses.map((bulkUploadStatus) => (
      return (
      <TableRow className={styles.tableBodyRow} key={bulkUserUploadStatuses.id}>
        <TableCell className={styles.tableCell}>
          {dayjs(bulkUserUploadStatuses?.creationTime).format('MM/DD/YYYY hh:mm:ssA')}
        </TableCell>

        <TableCell className={styles.tableCell}>
          {email}
        </TableCell>
        <TableCell sx={{ width: "250px" }} className={styles.tableCell}>
          {bulkUserUploadStatuses?.id}
        </TableCell>
        <TableCell className={styles.tableCell}>
          <StatusBadge status={bulkUserUploadStatuses?.currentStatus} />
        </TableCell>
      </TableRow>
    );
  };

  const renderLoaderInTableBody = () => {
    return (
      <TableRow>
        <TableCell sx={{ border: "none" }} colSpan={6}>
          <div className={styles.loaderContainer}>
            <div className={styles.loading}>{t('loading')}</div>
            <CircularProgress
              sx={{
                color: "black",
              }}
            />
          </div>
        </TableCell>
      </TableRow>
    );
  };
  const renderTable = () => {
    return (
      <>
        {(isFetching || Object.keys(bulkUserUploadStatuses).length > 0 ) && (
          <div>
            <p className={styles.results}>
              {bulkUserUploadStatuses.length} {t('results')}
            </p>
            <TableContainer className={styles.tableContainer}>
              <Table stickyHeader className={styles.userTable}>
                <TableHead>{renderTableHead()}</TableHead>
                <TableBody>
                  {isFetching ? renderLoaderInTableBody() : renderTableBody()}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </>
    );
  };

  return <div className={styles.container}>{renderTable()}</div>;
}

export default BulkUsersUploadStatuses;
